import { render, staticRenderFns } from "./TableDesign.vue?vue&type=template&id=23acd8f2&scoped=true"
import script from "./TableDesign.vue?vue&type=script&lang=js"
export * from "./TableDesign.vue?vue&type=script&lang=js"
import style0 from "./TableDesign.vue?vue&type=style&index=0&id=23acd8f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23acd8f2",
  null
  
)

export default component.exports